module.exports = __webpack_public_path__ + "img/dingle-main.a0444072.jpg";